<template>
    <div>
        <van-nav-bar style="background-color: #42b983">
            <template #title>
                <span style="color: #ffffff">合作伙伴列表</span>
            </template>
            <template #left>
                <router-link to="/my">
                    <van-icon name="arrow-left" color="#ffffff"/>
                    <span style="color: #ffffff">返回</span>
                </router-link>
            </template>
            <template #right>
                <router-link to="/">
                    <van-icon name="wap-home-o" color="#ffffff" size="1.3rem"/>
                </router-link>
            </template>
        </van-nav-bar>


        <van-row style="line-height: 50px;margin: 0 16px;"  justify="space-between" type="flex">
            <van-col>
                总计:{{listTotal}} 已装载 {{organs.length}}
            </van-col>

            <van-col>
                <van-button type="default" size="small" @click="changeSearchModel = true">查找</van-button>&nbsp;&nbsp;
            </van-col>
        </van-row>




        <van-list
                v-model="loading"
                :finished="finished"
                :error.sync="error"
                :error-text="error_text"
                finished-text="没有更多了"
                @load="onLoad(false)"
        >
            <van-collapse v-model="listActive">

                <van-panel style="margin: 0 16px" v-for="organ in organs" :key="organ.id">
                    <template #header>
                        <van-row  gutter="20" type="flex">
                            <van-col>
                                <van-image v-if="organ.creator.avatar" round width="50px" :src="organ.creator.avatar"/>
                                <van-image v-else round width="50px" :src="require('@/assets/logo.png')" />
                            </van-col>
                            <van-col>
                                <van-row>
                                    机构名称:{{organ.name}}
                                </van-row>
                                <van-row style="font-weight: 200">
                                    合作伙伴:{{organ.creator.nickname}}(ID:{{organ.creator.id}})
                                </van-row>
                            </van-col>
                        </van-row>
                    </template>

                    <div style="font-weight: 100">

                        联系人:&nbsp;{{organ.contact_name}}
                        <span v-if="organ.contact_phone">( <a :href="'tel:'+organ.contact_phone">{{organ.contact_phone}}</a>)</span>

                        <br>
                        提成微信号:&nbsp;{{organ.we_chat_number}}<br>
                        提成比例:&nbsp;{{organ.commission_percentage}}; &nbsp;&nbsp;上级提成比例:&nbsp;{{organ.pid_commission_percentage}}<br>
                        学员充值折扣:&nbsp;{{organ.discount_percentage}}<br>
                        本月用户:&nbsp;{{organ.user_num}}&nbsp;人;&nbsp;&nbsp;本月用户充值:&nbsp;{{organ.order_total}}元<br>
                    </div>

                </van-panel>


            </van-collapse>
        </van-list>


        <van-dialog v-model="changeSearchModel"
                    showCancelButton
                    @confirm="onLoad(true)"
                    title="机构查找">
            <van-row style="margin: 10px 20px">
                <van-search v-model="searchValue" placeholder="请输入机构名称"/>
            </van-row>
        </van-dialog>

    </div>
</template>

<script>
    export default {
        data() {
            return {
                page: 1,
                listTotal: 0,
                listActive: [],

                loading: false,
                finished: false,
                error: false,
                error_text: "",
                searchValue: "",

                changeSearchModel:false,

                organs: []
            };
        },
        created() {

        },
        methods: {
            onLoad(isNew) {
                if (isNew) {
                    this.organs = [];
                    this.page = 1;
                    this.finished = false;
                }
                this.loading = true;
                this.$http.get("/wechat/organs", {
                    params: {
                        pre_page: 15,
                        page: this.page,
                        word: this.searchValue
                    }
                }).then(res => {
                    this.loading = false;
                    console.log(res.data);
                    if (200 !== res.data.code) {
                        this.error = true
                        this.error_text = res.data.msg
                        return
                    }
                    if (!res.data.data || res.data.data.length <= 0) {
                        this.finished = true
                        return;
                    }
                    this.page++

                    this.listTotal = res.data.meta.total
                    this.organs = this.organs.concat(res.data.data);
                });
            }
        }
    }
</script>
